module.exports = __webpack_public_path__ + "fonts/sailec-bold.8f4bd467.otf";